import { useCallback } from 'react'

export default function CustomFieldValueLink({ href, children }) {
  const onClick = useCallback(event => event.stopPropagation(), [])
  return (
    <a href={href} rel="noopener noreferrer" target="_blank" onClick={onClick}>
      {children}
    </a>
  )
}
